
import axios from "axios";

const APIURL = (window.location.hostname === 'localhost'
    || window.location.hostname === 'nzen') ? 'http://nzen/jo/api-lib/App/Admin_App' : 'https://view.optigoapps.com/linkedapp/App/Admin_App';
    // || window.location.hostname === 'hoq.web') ? 'http://zen/api/ReactStore.aspx' : 'https://api.optigoapps.com/test/ReactStore.aspx';

export const CommonAPI = async (body) => {
    try {
        const response = await axios.post(APIURL, body);
        return response?.data;

    } catch (error) {
        console.error('error is..', error);
    }
};






// import axios from "axios";
// // const APIURL = 'https://api.optigoapps.com/storev26/store.aspx';
// // const APIURL = 'http://zen/api/ReactStore.aspx'
// // const APIURL = (window.location.hostname === 'localhost' || window.location.hostname === 'zen') ? 'http://zen/api/ReactStore.aspx' : 'https://api.optigoapps.com/storev26/ReactStore.aspx';
// const APIURL = (window.location.hostname === 'localhost'
//     || window.location.hostname === 'zen') ? 'http://zen/api/ReactStore.aspx' : 'https://api.optigoapps.com/ReactStore/ReactStore.aspx';
//     // || window.location.hostname === 'hoq.web') ? 'http://zen/api/ReactStore.aspx' : 'https://api.optigoapps.com/test/ReactStore.aspx';


    
// // const APIURL = 'https://api.optigoapps.com/test/store.aspx';
// // const NEWAPIURL = 'https://api.optigoapps.com/storev26/ReactStore.aspx';
// // const ZENURL = 'http://zen/api/store.aspx'


// export const CommonAPI = async (body) => {
//     const storeInit = JSON.parse(sessionStorage.getItem('storeInit'));
//     try {
//         const YearCode = storeInit?.YearCode ?? '' ;
//         const version = storeInit?.version  ?? '';
//         const token = storeInit?.token ?? '';
//         const sv = storeInit?.sv ?? '';

//         const header = {
//             Authorization: `Bearer ${token}`,
//             Yearcode: YearCode,
//             Version: version,
//             sp: "1",
//             sv: sv
//         };
//         const response = await axios.post(APIURL, body, { headers: header });
//         return response?.data;

//     } catch (error) {
//         console.error('error is..', error);
//     }
// };

